import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BriefcaseFilled2: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 20, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 18) / 20}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.005 3.23435H13.6976V1.49872C13.6976 0.672298 13.0252 0 12.1988 0H7.80094C6.97449 0 6.30212 0.672298 6.30212 1.49872V3.23435H1.99466C0.897367 3.23435 0.0046214 4.12705 0.0046214 5.2243C0.0046214 6.22099 -0.0974553 7.11608 0.657865 8.12268C1.08522 8.69219 1.67248 9.09846 2.35616 9.29749L8.99507 11.2304C9.65232 11.4217 10.3472 11.4218 11.0046 11.2304L17.6435 9.29749C18.3271 9.09842 18.9144 8.69219 19.3418 8.12268C20.1005 7.11155 19.995 6.20726 19.995 5.2243C19.995 4.12705 19.1023 3.23435 18.005 3.23435ZM7.57163 1.49872C7.57163 1.37229 7.6745 1.26946 7.80094 1.26946H12.1988C12.3252 1.26946 12.4281 1.37233 12.4281 1.49872V3.23435H7.57163V1.49872Z"
        fill="currentColor"
      />
      <path
        d="M17.9977 10.5162C10.8368 12.601 10.9295 12.6432 9.9991 12.6432C9.07537 12.6432 9.29452 12.6398 2.00057 10.5162C1.23153 10.2923 0.550432 9.87954 0.00390625 9.31055V15.4022C0.00390625 16.4995 0.896612 17.3921 1.99395 17.3921H18.0043C19.1016 17.3921 19.9943 16.4995 19.9943 15.4022V9.31055C19.4478 9.8795 18.7667 10.2923 17.9977 10.5162Z"
        fill="currentColor"
      />
    </svg>
  )
})

BriefcaseFilled2.displayName = 'BriefcaseFilled2'
